import { matchRoutes, useLocation } from 'react-router-dom';

export const useRouteMatch = (routes) => {
  const { pathname } = useLocation();

  const menuMatchRoutes = matchRoutes(routes, pathname);

  const { length, [length - 1]: routeItem } = menuMatchRoutes;

  return routeItem;
};
